/**
 * Created by RSchweber-Koren on 3/24/2017.
 */
class TrackingEventEditorFlowCancelledError extends Error {
    constructor({flowName, flowWasUserCancelled}) {
        super(`Event Editor flow '${flowName}' cancelled`);
        this.name = "TrackingEventEditorFlowCancelledError";
        this.userCancelledFlow = flowWasUserCancelled;
    }
}

export default TrackingEventEditorFlowCancelledError;


//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-event-editor/TrackingEventEditorFlowCancelledError.js
// module id = hbOK
// module chunks = 1